import { render, staticRenderFns } from "./AbonementShop.vue?vue&type=template&id=58f3686e&scoped=true&lang=pug&"
import script from "./AbonementShop.vue?vue&type=script&lang=js&"
export * from "./AbonementShop.vue?vue&type=script&lang=js&"
import style0 from "./AbonementShop.vue?vue&type=style&index=0&id=58f3686e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f3686e",
  null
  
)

/* custom blocks */
import block0 from "./AbonementShop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports